/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';

export class PersonAutocompleteVoModel extends JSONable {
  uuid: string | undefined = undefined;
  name: string | undefined = undefined;
  idSeries: string | undefined = undefined;
  idNumber: string | undefined = undefined;
  cnp: string | undefined = undefined;
  address: string | undefined = undefined;
  county: string | undefined = undefined;
}
